import { Button } from "@/components/ui/button";
import type { ComponentType } from "react";

import { useChatSurface, useMessageId } from "../surface.tsx";
import type { UiComponentProps } from "./registry.tsx";

/**
 * Lo que se dibuja en lugar de un componente que no cabe (§9).
 *
 * Enseña lo que el modelo NOMBRÓ --su título-- y qué es, y ofrece abrirlo
 * donde sí cabe. Deliberadamente NO enseña datos: ni cuenta filas ni resume
 * totales, porque para saberlos habría que pedir el dataset, y un número
 * suelto arrancado de una tabla es justo lo que la regla de oro de la sección
 * 9 evita. De paso, un gráfico compacto no carga la librería de gráficos.
 */
export const compactCard = (
  kind: string,
  Icon: ComponentType<{ className?: string }>,
): ComponentType<{ props: UiComponentProps }> =>
  function CompactCard({ props }) {
    const { openInChat } = useChatSurface();
    const messageId = useMessageId();
    const title = typeof props["title"] === "string" ? props["title"] : null;

    return (
      <div className="flex items-center gap-3 rounded-lg border bg-card px-3 py-2.5">
        <Icon className="size-5 shrink-0 text-muted-foreground" aria-hidden />

        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium">{title ?? kind}</p>
          <p className="text-xs text-muted-foreground">
            {title === null ? "No cabe aquí" : `${kind} · no cabe aquí`}
          </p>
        </div>

        {openInChat !== undefined && messageId !== null && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              openInChat(messageId);
            }}
          >
            Ver en el chat
          </Button>
        )}
      </div>
    );
  };
